module.exports = __webpack_public_path__ + "img/two.10e19c03.png";